import DayTwoOperation from '@shell/models/day-two-operation';

export default class EtcdSnapshotSave extends DayTwoOperation {}
